import { flexRender } from "@tanstack/react-table";
import { ArrowIcon } from "assets/icons";
import cn from "classnames";
import { If } from "components";

import { TableHeadProps } from "../ItemsTableDragDrop.types";

import styles from "../ItemsTableDragDrop.module.scss";

const TableHead = <TData extends { id: string }>({
  table
}: TableHeadProps<TData>) => {
  return (
    <thead>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className={styles.table_headerRow}>
          {headerGroup.headers.map((header) => (
            <th
              key={header.id}
              className={cn(styles.table_headerCell, {
                [styles.table_headerCell__sorted]: header.column.getIsSorted(),
                [styles.table_headerCell__sorting]: header.column.getCanSort()
              })}
              style={{ width: `${header.getSize()}%` }}
            >
              <div
                className={styles.table_headerCell_content}
                onClick={header.column.getToggleSortingHandler()}
              >
                <div>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </div>

                <If condition={header.column.getCanSort()}>
                  <ArrowIcon
                    width={18}
                    height={18}
                    className={cn(styles.table_headerCell_sortArrow, {
                      [styles.table_headerCell_sortArrow__rotated]:
                        header.column.getIsSorted() === "asc"
                    })}
                  />
                </If>
              </div>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};

export default TableHead;
